// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <div id="vaForms" />
      <h1>VA Forms</h1>
      <h2 id="november-20%2C-2019">November 20, 2019</h2>
      <p>Initial release of the VA Forms API</p>
    </div>
  );
};

export default MarkdownComponent;
